import {
  inject, observer,
} from 'mobx-react';
import * as React from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import {
  IAuthStore,
} from '../../mobx-store/storeInterfaces/authInterface';
import NavigationItems from './NavigationItems/NavigationItems';
import styles from './styles.module.scss';

interface IProps {
  authStore?: IAuthStore;
}

@inject('authStore')
@observer
class NavBar extends React.Component<IProps & RouteComponentProps, {}> {
  public render() {
    return (
      <nav className={styles.navBar}>
        <div className={styles.items}>
          <NavigationItems />
          <div />
        </div>
      </nav>
    );
  }
}

export default withRouter(NavBar);
